import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, ArrowRight, Users, Eye } from 'lucide-react';
import EquiposEnAccion from './EquiposEnAccion';

// Rutas estáticas desde public/ para que las imágenes carguen en Amplify (evita /static/media/)
const getBaseUrl = () =>
  typeof window !== 'undefined' ? window.location.origin : (process.env.PUBLIC_URL || '');

const videoCards = [
  {
    image: '/img/monitoreo/yt/myt1.jpg',
    title: 'Generalidades sobre la Carga de Entrenamiento',
    description: 'En esta entrada, vamos a sumergirnos en un concepto esencial en el entrenamiento deportivo: la carga de entrenamiento. Aprenderemos sobre la carga interna y externa y cómo estas influencian el rendimiento del atleta.',
    url: 'https://www.youtube.com/watch?v=Z8POyzdemUE&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=8',
  },
  {
    image: '/img/monitoreo/yt/myt2.jpg',
    title: 'Monitoreo de carga de entrenamiento con la App +Trainer',
    description: 'Aprenderás a establecer objetivos personalizados, registrar tus sesiones de entrenamiento, y aprovechar las herramientas de análisis que +Trainer tiene para ofrecerte. Conocerás cómo interpretar los datos clave que te ayudarán a ajustar tu rutina y asegurarte de estar en el camino correcto hacia tus metas de entrenamiento.',
    url: 'https://www.youtube.com/watch?v=4-HGozFJUc4&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd',
  },
  {
    image: '/img/monitoreo/yt/myt3.jpg',
    title: 'Carga Interna y Externa de Entrenamiento con la App +Trainer',
    description: 'Nuestra herramienta les brinda a los entrenadores un control total sobre la carga de entrenamiento de los atletas, para ayudar a evitar el sobreentrenamiento y la fatiga.',
    url: 'https://www.youtube.com/watch?v=U-hR-KUc66o&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=3',
  },
  {
    image: '/img/monitoreo/yt/myt4.jpg',
    title: 'Cómo Armar y Gestionar un Grupo de Control y Monitoreo de Carga Interna Subjetiva en la App +Trainer',
    description: 'Optimizá el Rendimiento de los Atletas: Armando y Gestionando un Grupo de Control y Monitoreo de Carga Interna Subjetiva en la App +Trainer',
    url: 'https://www.youtube.com/watch?v=kr6Z_Qp_HHk&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=11',
  },
];

const planificacionVideoCards = [
  {
    image: '/img/planificacion/yt/eyt1.jpg',
    title: 'Diagnóstico Previo al Diseño del Plan de Entrenamiento',
    description: 'En esta entrada abordaremos un tema esencial para cualquier entrenador o atleta serio: el diagnóstico inicial previo a iniciar un entrenamiento. Este paso crucial es fundamental para desarrollar programas de entrenamiento efectivos y adaptados a la realidad de cada individuo.',
    url: 'https://www.youtube.com/watch?v=BzWHXaerXXg&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=5',
  },
  {
    image: '/img/planificacion/yt/eyt2.jpg',
    title: 'Objetivos del Entrenamiento de Fuerza',
    description: 'En este video, nos sumergimos en los objetivos fundamentales del entrenamiento de fuerza, centrándonos en las distintas manifestaciones y las respuestas adaptativas clave del cuerpo.',
    url: 'https://www.youtube.com/watch?v=7kPPGgyEWwI&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=6',
  },
  {
    image: '/img/planificacion/yt/eyt3.jpg',
    title: 'Tipos de Estrés en el Entrenamiento de Fuerza',
    description: 'En este blog, profundizaremos en un aspecto crucial del entrenamiento de fuerza: los diferentes tipos de estrés que influyen en los resultados de los atletas. Comprender el estrés mecánico, el tiempo bajo tensión, el estrés metabólico y el estrés hormonal es esencial para ajustar y maximizar los programas de entrenamiento de fuerza.',
    url: 'https://www.youtube.com/watch?v=3TW6eM24AtM&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=7',
  },
  {
    image: '/img/planificacion/yt/eyt4.jpg',
    title: 'Clasificación de los Ejercicios de Fuerza con +Trainer',
    description: 'Aprende a seleccionar ejercicios específicos que se alineen con tus objetivos de fuerza, utilizando la amplia gama de clasificaciones proporcionadas por +Trainer. Te mostramos cómo personalizar la rutina de los atletas para maximizar las ganancias de fuerza de manera segura y eficaz.',
    url: 'https://www.youtube.com/watch?v=P-xRPvN5HA8&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=4',
  },
];

const prevencionVideoCards = [
  {
    image: '/img/prevencion/yt/pyt1.jpg',
    title: 'Predicción del Riesgo Lesional con +Trainer',
    description: 'Optimizá el Rendimiento y Minimizá Riesgos de lesiones de los atletas con la Función de Predicción de Riesgo Lesional de +Trainer',
    url: 'https://www.youtube.com/watch?v=KT5DR6VwZZ0&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=9',
  },
  {
    image: '/img/prevencion/yt/pyt2.jpg',
    title: 'Entrenamiento: Estabilidad de Zona Media (Core) con +Trainer',
    description: 'En esta entrada profundizaremos en una de las áreas fundamentales del entrenamiento: la estabilidad de la zona media, también conocida como el core. Veremos por qué fortalecer esta región es esencial para generar fuerza en los miembros y maximizar el rendimiento de los atletas.',
    url: 'https://www.youtube.com/watch?v=XJFVhn2hUdA&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=12',
  },
  {
    image: '/img/prevencion/yt/pyt3.jpg',
    title: 'Entrenamiento: Estabilidad de los MMII con +Trainer',
    description: 'En esta entrada veremos el entrenamiento enfocado en la estabilidad de miembros inferiores con la app +Trainer. En este video, nos sumergiremos en la importancia crucial de trabajar tanto la estabilidad estática como la dinámica en la parte inferior del cuerpo para mantener el equilibrio y el control postural durante el movimiento o la traslación del cuerpo.',
    url: 'https://www.youtube.com/watch?v=WvDZtnt_mQk&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=14',
  },
  {
    image: '/img/prevencion/yt/pyt4.jpg',
    title: 'Entrenamiento: Flexibilidad con +Trainer',
    description: 'Optimizá la Movilidad de los Atletas: Trabajo de Flexibilidad con +Trainer',
    url: 'https://www.youtube.com/watch?v=bUgFgAVj0xU&list=PLLacyoPWpl2-0liCoMOg9xK-uO7eFGoFd&index=13',
  },
];

interface OnFieldRolesProps {
  activeRole: string;
  onRoleChange: (role: string) => void;
  onDownloadClick?: () => void;
}

const OnFieldRoles: React.FC<OnFieldRolesProps> = ({ activeRole, onRoleChange, onDownloadClick }) => {
  const [selectedBenefit, setSelectedBenefit] = useState(0);

  const roles = [
    {
      id: 'seguidor',
      title: 'Planes de Entrenamiento',
      icon: Eye,
      color: 'mas10-secondary',
      sectionName: 'Seguidores',
      benefits: [
        'VISTA PREVIA',
        'FUNCIONALIDAD',
        'IMPORTANCIA'
      ],
      radarFeatures: [
        'Equipos Cercanos: Encontrá equipos de tu zona para seguir',
        'Partidos en Vivo: Ubicá canchas donde se juegan partidos',
        'Comunidad Local: Conectá con hinchas de tu barrio'
      ]
    },
    {
      id: 'jugador',
      title: 'Monitoreo de la Carga de Entrenamiento',
      icon: User,
      color: 'mas10-secondary',
      sectionName: 'Jugadores',
      benefits: [
        'VISTA PREVIA',
        'FUNCIONALIDAD',
        'IMPORTANCIA'
      ],
      radarFeatures: [
        'Partidos Cercanos: Encontrá partidos a tu alrededor',
        'Equipos que Buscan: Ubicá equipos que necesitan jugadores',
        'Canchas Disponibles: Descubrí espacios para entrenar'
      ]
    },
    {
      id: 'gestiono-equipo',
      title: 'Prevención de Lesiones',
      icon: Users,
      color: 'mas10-secondary',
      sectionName: 'Equipos',
      benefits: [
        'VISTA PREVIA',
        'FUNCIONALIDAD',
        'IMPORTANCIA'
      ],
      radarFeatures: [
        'Mercado de Pases: Encontrá al jugador que te falta',
        'Partidos Amistosos: Conectá con rivales de tu nivel',
        'Torneos y Predios: Encontrá dónde jugar siempre'
      ]
    }
  ];

  const activeRoleData = roles.find(role => role.id === activeRole);
  // Orden mostrado: VISTA PREVIA (2), FUNCIONALIDAD (0), IMPORTANCIA (1)
  const contentIndexForDisplay = [2, 0, 1];

  return (
    <section id="entrenadores" className="section-padding bg-gray-50">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-mas10-dark mb-6">
            Entrenador: Enfoque Integral
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Herramientas de vanguardia para optimizar los planes de entrenamiento, monitorear la carga de trabajo y reducir el riesgo de lesiones
          </p>
        </motion.div>

        {/* Role Tabs */}
        <div className="flex flex-col sm:flex-row gap-4 mb-12 justify-center">
          {roles.map((role) => (
            <motion.button
              key={role.id}
              onClick={() => onRoleChange(role.id)}
              className={`relative px-8 py-6 rounded-full font-semibold text-lg transition-all duration-300 ${
                activeRole === role.id
                  ? 'bg-' + role.color + ' text-white shadow-lg transform scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border-2 border-gray-200'
              }`}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {role.title}
            </motion.button>
          ))}
        </div>

        {/* Main Content */}
        <AnimatePresence mode="wait">
          {activeRole === 'gestiono-equipo' || activeRole === 'jugador' || activeRole === 'seguidor' ? (
            // Para equipos: mostrar los 3 componentes siempre visibles
            <motion.div
              key={activeRole}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.5 }}
              className="grid md:grid-cols-3 gap-8 mb-12"
            >
              {contentIndexForDisplay.map((contentIndex, i) => (
                <motion.div
                  key={contentIndex}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <EquiposEnAccion 
                    selectedBenefit={contentIndex} 
                    activeRole={activeRole}
                    benefits={activeRoleData?.benefits || []}
                    onDownloadClick={onDownloadClick}
                  />
                </motion.div>
              ))}
            </motion.div>
          ) : (
            // Para otros roles: mantener el comportamiento original
            <motion.div
              key={activeRole}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.5 }}
              className="grid lg:grid-cols-2 gap-8 mb-12"
            >
              {/* Left: Role Benefits */}
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="bg-white rounded-3xl shadow-xl p-8"
              >
                <div className={`inline-flex items-center justify-center w-16 h-16 bg-${activeRoleData?.color} rounded-2xl mb-6`}>
                  {activeRoleData?.icon && React.createElement(activeRoleData.icon, { className: "w-8 h-8 text-white" })}
                </div>
                
                <h3 className="text-3xl font-display font-bold text-mas10-dark mb-6">
                  {activeRoleData?.title}
                </h3>
                
                <ul className="space-y-4">
                  {activeRoleData?.benefits.map((benefit, index) => (
                    <motion.li
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      className={`flex items-start space-x-3 cursor-pointer p-3 rounded-lg transition-all duration-300 ${
                        selectedBenefit === index 
                          ? 'bg-mas10-accent/10 border-2 border-mas10-accent' 
                          : 'hover:bg-gray-50'
                      }`}
                      onClick={() => setSelectedBenefit(index)}
                    >
                      <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors ${
                        selectedBenefit === index 
                          ? 'bg-mas10-accent' 
                          : 'bg-mas10-accent/50'
                      }`}>
                        <ArrowRight className="w-3 h-3 text-mas10-dark" />
                      </div>
                      <span className={`text-lg transition-colors ${
                        selectedBenefit === index 
                          ? 'text-mas10-dark font-semibold' 
                          : 'text-gray-700'
                      }`}>
                        {benefit}
                      </span>
                    </motion.li>
                  ))}
                </ul>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="mt-8 group btn-primary"
                  onClick={()=>onDownloadClick?.()}
                >
                  Empezar Ahora
                  <ArrowRight className="inline-block w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </motion.button>
              </motion.div>

              {/* Right: Equipos en Acción */}
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <EquiposEnAccion 
                  selectedBenefit={contentIndexForDisplay[selectedBenefit]} 
                  activeRole={activeRole}
                  benefits={activeRoleData?.benefits || []}
                  onDownloadClick={onDownloadClick}
                />
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* TUTORIALES: título dinámico y carrusel según opción seleccionada */}
        {(activeRole === 'seguidor' || activeRole === 'jugador' || activeRole === 'gestiono-equipo') && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mt-16"
          >
            <h2 className="text-3xl font-display font-bold text-mas10-dark text-center mb-8">
              TUTORIALES: {activeRoleData?.title}
            </h2>
            {(activeRole === 'jugador' || activeRole === 'seguidor' || activeRole === 'gestiono-equipo') ? (
              <div className="flex flex-col md:flex-row md:overflow-x-auto gap-6 pb-4 md:snap-x md:snap-mandatory">
                {(activeRole === 'jugador' ? videoCards : activeRole === 'seguidor' ? planificacionVideoCards : prevencionVideoCards).map((card, index) => (
                  <motion.a
                    key={index}
                    href={card.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full md:flex-shrink-0 md:w-[300px] min-h-[420px] md:snap-center rounded-2xl overflow-hidden bg-mas10-primary text-white shadow-xl hover:shadow-2xl transition-shadow duration-300 group flex flex-col"
                    whileHover={{ y: -4 }}
                  >
                    <div className="relative aspect-video w-full overflow-hidden flex-shrink-0">
                      <img
                        src={getBaseUrl() + card.image}
                        alt={card.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-4 flex-1 flex flex-col">
                      <h3 className="font-display font-bold text-sm mb-1.5 line-clamp-2">{card.title}</h3>
                      <p className="text-xs text-white/90 line-clamp-5 flex-1">{card.description}</p>
                    </div>
                  </motion.a>
                ))}
              </div>
            ) : null}
          </motion.div>
        )}

      </div>
    </section>
  );
};

export default OnFieldRoles;
